<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-search placeholder="账单主体" @search="searchKey" style="margin-right: 5px;" />
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false"/>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/Finance'
import {errorHandler} from '../../../utils/errorHandler'
import {bus} from '../../../utils/bus'
import {nError, nSuccess} from '../../../utils/notice'

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb},
  name: 'electronic-finance-settlement-record',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '智慧财务',
        name: 'finance-over-view'
      }, {
        value: '退租账单管理'
      }],
      exportUrl: '',
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      tableHead: [{
        prop: 'enterpriseName',
        label: '账单主体',
        width: '400'
      }, {
        prop: 'feeType',
        label: '费用类型'
      }, {
        prop: 'typeText',
        label: '收/退款类型'
      },{
        prop: 'dueIncomeOrBackAmount',
        label: '应收/退金额(元)'
      }, {
        prop: 'realIncomeOrBackAmount',
        label: '实收/退金额(元)'
      },  {
        prop: 'statusText',
        label: '状态'
      }, {
        prop: 'time',
        label: '收/退款时间'
      }, {
        prop: 'memo',
        label: '备注'
      }],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      timeValue: [],
      requestData: {
        searchKey: ''
      },
      currentLineData: {},
      formData: {
        parentCode:'-1'
      }
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getCurrentTime()
  },
  activated() {
    this.getPage()
  },
  methods: {
    getCurrentTime () {
      let nowDate = new Date
      let year = nowDate.getFullYear()
      let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
      let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
      // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timeValue[0] = year + '-' + month + '-' + date
      this.timeValue[1] = year + '-' + month + '-' + date
      this.getPage()
    },
    beforeDownload () {
      if (this.timeValue.length > 0) {
        this.exportUrl = `${api.exportElectricConsumptionRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&startTime=${this.timeValue[0]} 00:00:00&endTime=${this.timeValue[1]} 23:59:59`
      } else {
        this.exportUrl = `${api.exportElectricConsumptionRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}`
      }
    },
    changeTimeValue () {
      this.pageNum = 1
      this.pageSize = 10
      this.getPage()
    },
    getPage () {
      this.$axios.post(api.getSurrenderBillPage,this.formData).then(res=>{
        this.tableData=res.data.data.list
        this.total=res.data.data.total
        this.tableData.map(v=>{
          if(v.type=='back'){
            v.typeText='退款'
          }else if(v.type=='income'){
            v.typeText='收款'
          }
          if(v.status=='1'){
            v.statusText='未退款'
          }else if(v.status=='2'){
            v.statusText='已退款'
          }else if(v.status=='3'){
            v.statusText='未收款'
          }else if(v.status=='4'){
            v.statusText='已收款'
          }
          v.childNode.map(u=>{
            if(u.type=='back'){
              u.typeText='退款'
            }else if(u.type=='income'){
              u.typeText='收款'
            }
            if(u.status=='1'){
              u.statusText='未退款'
            }else if(u.status=='2'){
              u.statusText='已退款'
            }else if(u.status=='3'){
              u.statusText='未收款'
            }else if(u.status=='4'){
              u.statusText='已收款'
            }
          })
          v.children=v.childNode
        })
      })
      // this.$axios.post(api.getSettlementPage, reqData)
      //   .then(res => {
      //     let data = res.data.data.list
      //     data.map(v => {
      //       if (v.payTime) {
      //         v.payTime = v.payTime.slice(0, 19)
      //       }
      //     })
      //     this.total = res.data.data.total
      //     this.tableData = data
      //   })
      //   .catch(errorHandler('获取结算记录失败'))
    },
    searchKey (v) {
      this.pageNum = 1
      this.formData.searchKey = v
      this.getPage()
    },
    search (v) {
      this.requestData[v.key] = v.value
      this.getPage()
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
  }
}
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
.el-input--small .el-input__inner {
  line-height: 30px;
}
.el-select-dropdown {
  min-height: 100px;
}

.all-table-class .el-table .cell{
  display: flex;
  justify-content:center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/view/Finance/refundBillManagement/refundBillManagement.vue